import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Highmark Blue Cross Blue Shield of Western New York",
  shortName: "Highmark BCBS WNY",
  slug: "highmark-bcbs-wny-insurance",
  seoTitle:
    "Highmark Blue Cross Blue Shield of Western New York TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Highmark Blue Cross Blue Shield of Western New York policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Highmark BCBS WNY TMS coverage, Highmark Blue Cross Western New York SPRAVATO authorization, Highmark WNY mental health benefits Coral Springs FL",
};

export const HighmarkBcbsWnyInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default HighmarkBcbsWnyInsurance;
